import Logo from './svg/dw-logo-white.svg?react';

export const StyledLogoWhite = Logo;
